import { useEffect } from "react";
import { useSuccess } from "./successContext";
import {
  registerGlobalSuccessSetter,
  unregisterGlobalSuccessSetter,
} from "./globalSuccess";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar from "@mui/material/Snackbar";
import Typography from "@mui/material/Typography";

export default function SuccessGlobalAlert() {
  const { success, setSuccess } = useSuccess();

  useEffect(() => {
    registerGlobalSuccessSetter(setSuccess);
    return () => unregisterGlobalSuccessSetter();
  }, [setSuccess]);

  return (
    <Snackbar
      open={!!success}
      autoHideDuration={2000}
      onClose={() => setSuccess(null)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        severity="success"
        onClose={() => setSuccess(null)}
        variant="standard"
      >
        <AlertTitle>Success</AlertTitle>
        <Typography sx={{ fontFamily: "'Prompt', 'sans-serif'" }}>
          {success ?? "Success"}
        </Typography>
      </Alert>
    </Snackbar>
  );
}
